window.CtrUtils = window.CtrUtils || {};

window.CtrUtils.matchHeights = function matchHeights(selector) {
  const elements = document.querySelectorAll(selector);
  let maxHeight = 0;

  elements.forEach((element) => {
    const height = element.offsetHeight;
    if (height > maxHeight) {
      maxHeight = height;
    }
  });

  elements.forEach((element) => {
    element.style.minHeight = maxHeight + 'px';
  });
};
